import {
  QueryClient,
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'

import { RequestErrorType } from '@core/utils/api-axios-instance'
import { IBriefingSession } from '@core/entities/briefing'
import { briefingKeys, RequestTypes } from '@core/react-query/features/briefing'
import { optimisticallyHandleBriefingSession } from '@core/react-query/features/briefing/helpers'

export const getCreateBriefingSessionMutationOptions = (
  queryClient: QueryClient,
  options: Parameters<typeof useCreateBriefingSession>[0] = {},
): Parameters<typeof useCreateBriefingSession>[0] => {
  return {
    ...(options ?? {}),
    ...briefingKeys.createBriefingSession,
    onSuccess: (...args) => {
      const [data] = args

      optimisticallyHandleBriefingSession(queryClient, data)
      options?.onSuccess?.(...args)
    },
  }
}

export const useCreateBriefingSession = (
  options: UseMutationOptions<
    IBriefingSession,
    RequestErrorType,
    RequestTypes['createBriefingSession']
  > = {},
) => {
  const queryClient = useQueryClient()

  return useMutation(
    getCreateBriefingSessionMutationOptions(queryClient, options),
  )
}
